import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { CommonService } from '../services/common.service';
import { DataService } from '../services/data.service';
import { User, UserDto, Authorization, ApplicationRoles, Roles, RoleDto } from '../models/data.model';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  companies: any[] = [];
  model: any;
  utenti: User[] = [];

  detail: User;



  Username: string = '';
  Password: string = '';
  Nome: string = '';
  Cognome: string = '';
  Email: string = '';
  return: string = '';

  addUserForm: FormGroup;
  addRoleForm: FormGroup;
  addApplicazioneRoleForm: FormGroup;
  removeRoleForm: FormGroup;

  submitted = false;

  @ViewChild('instance') instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  formatter = (x: { displayName: string }) => x.displayName;
  srch: User = null;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private userService: CommonService<User>,
    private applicationRolesService: CommonService<ApplicationRoles>,
    private rolesService: CommonService<Roles>,
    private dataService: DataService
  ) { }

  //userEmail = this.userService.getPrincipal().username;

  get userEmailAsync() {
    return (async () => {
      return await this.userService.getPrincipalAsync();
    })();
  }

  get f() { return this.addUserForm.controls; }
  get g() { return this.addRoleForm.controls; }
  get h() { return this.addApplicazioneRoleForm.controls; }
  get i() { return this.removeRoleForm.controls; }

  ngOnInit() {
    this.getUsers();
    this.getRoles();

    this.addUserForm = this.formBuilder.group({
      Nome: new FormControl(),
      Cognome: new FormControl(),
      Email: new FormControl(),
      Password: new FormControl(),
      Username: new FormControl()
    });

    this.addRoleForm = this.formBuilder.group({
      Ruolo: new FormControl()
    });

    this.addApplicazioneRoleForm = this.formBuilder.group({
      RuoloApp: new FormControl(),
      App: new FormControl()
    });

    this.removeRoleForm = this.formBuilder.group({
      RemoveRoleApplicazione: new FormControl(),
      RemoveRole: new FormControl()
    });
  }

  public ngAfterViewInit() {
  }

  filterUser = (r) => {
    this.srch = r;
    console.log(this.srch);
  }
  findDetailUser = (r: string) => {
    this.currentDetailUser = r;
  }

  currentDetailUser = "";
  showForm = false;
  showAll = true;
  showUserSaved = false;
  showUserNotSaved = false;
  showRoleSaved = false;
  showRoleNotSaved = false;
  showApplicationSaved = false;
  showApplicationNotSaved = false;
  errorMessage = "";
  showDetail = false;
  showSelectRuoli = false;
  showSelectApplicazioni = false;
  showRoleNotRemoved = false;
  showRoleRemoved = false;
  showUserNotDeleted = false;
  showUserDeleted = false;

  currentUser: string = "";

  getUsers = async () => {
    let url = 'api/user/autenticazioneprofilazionegetallusersbyapplicationasync';
    const user = await this.userService.getPrincipalAsync();
    let params = { params: { authEmailAddress: user.username, application: "ePortal" } };
    this.userService.getData(url, params, false).subscribe(result => {
      this.utenti = result['result'].Utenti as User[];
      //console.log("this is list of users : ", result['result'].Utenti[0].EmailAddress);
      //console.log("this is list of users : ", result);
      this.utenti.forEach(x => {
        x.id = null;
      });
    });
    return this.utenti;
  }

  ruoli: string[] = [];

  getRoles = async () => {
    let rolesResult: Roles = new Roles();
    let url = 'api/user/autenticazioneprofilazionegetroles';
    const user = await this.userService.getPrincipalAsync();
    let params = { params: { authEmailAddress: user.username} };
    this.rolesService.getData(url, params, false).subscribe(result => {
      rolesResult = result as Roles;
      rolesResult['result'].forEach(x => {
        this.ruoli.push(x['CodiceRuolo']);
      });
    });
  }

  applicazioniRuoli: string[] = [];
  applicazioneCorrente: string = "";
  getApplicationRoles = (email: string) => {
    this.applicazioniRuoli = [];
    let applicationRolesResult: ApplicationRoles = new ApplicationRoles();
    let url = 'api/user/autenticazioneprofilazionegetuserrolesbyapplicationasync';
    let applicazioniTutte: string[] = ['QMX', 'eTender', 'Promotional', 'ePortal'];
    let ruoliString: string = "";
    let params = {};

    applicazioniTutte.forEach(async app => {
      ruoliString = "";
      const user = await this.userService.getPrincipalAsync();
      params = { params: { authEmailAddress: user.username, applicationCode: app, emailAddress: email } };
      this.applicationRolesService.getData(url, params, false).subscribe(result => {
        applicationRolesResult = result as ApplicationRoles;
        let stato = applicationRolesResult['result']['Stato'];
        let ruoli = applicationRolesResult['result']['Ruoli'];
        if (stato == 'OK') {
          ruoli.forEach(role => {
            ruoliString += role['CodiceRuolo'] + " ";
          });
          this.applicazioniRuoli[app] = ruoliString;
          ruoliString = "";
        }
      });
    });
    console.log(this.applicazioniRuoli);
    ruoliString = "";
  }

  addUser = async () => {
    this.submitted = true;
    const user = await this.userService.getPrincipalAsync();
    console.log(this.addUserForm.value.Username);
    let addUserInfo = new UserDto();
    addUserInfo.username = this.addUserForm.value.Username;
    addUserInfo.passwordFirma = this.addUserForm.value.Password;
    addUserInfo.authEmailAddress = user.username;
    addUserInfo.fName = this.addUserForm.value.Nome;
    addUserInfo.sName = this.addUserForm.value.Cognome;
    addUserInfo.emailAddress = this.addUserForm.value.Email;
    if (this.addUserForm.invalid) {
      return;
    }
    this.userService.postData('api/user/createuser', addUserInfo, false).subscribe(result => {
      if (result != null || result['statusCode'] == 200) {
        if (result['result']['code'] == 400) {
          this.showAll = true;
          this.errorMessage = result['result']['message'];
          this.showUserNotSaved = true;
          setInterval(() => {
            this.showUserNotSaved = false;
          }, 20000)
        } else {
          this.showAll = true;
          this.showForm = false;
          this.showUserSaved = true;
          console.log(result['result']['Code']);
          setInterval(() => {
            this.showUserSaved = false;
          }, 6000)
        }
      } else {
        this.showAll = true;
        this.showUserNotSaved = true;
        setInterval(() => {
          this.showUserNotSaved = false;
        }, 20000)
      }
    });
  }

  removeUser = async () => {
    if (window.confirm("Stai per cancellare l'utente " + this.currentUser)) {
      const user = await this.userService.getPrincipalAsync();
      let removeUserInfo = new UserDto();
      removeUserInfo.authEmailAddress = user.username;
      removeUserInfo.emailAddress = this.currentUser;
      this.userService.postData('api/user/deleteuser', removeUserInfo, false).subscribe(result => {
        if (result != null || result['statusCode'] == 200) {
          if (result['result']['code'] == 400) {
            this.showAll = true;
            this.showDetail = false;
            this.errorMessage = result['result']['message'];
            this.showUserNotDeleted = true;
            setInterval(() => {
              this.showUserNotDeleted = false;
            }, 20000)
          } else {
            this.showAll = true;
            this.showDetail = false;
            this.showUserDeleted = true;
            console.log(result['result']['Code']);
            setInterval(() => {
              this.showUserDeleted = false;
            }, 20000)
          }
        } else {
          this.showAll = true;
          this.showDetail = false;
          this.showUserNotDeleted = true;
          setInterval(() => {
            this.showUserNotDeleted = false;
          }, 20000)
        }
      });
    }
  }

  addRole = async (ApplicazioneForm: boolean) => {
    const user = await this.userService.getPrincipalAsync();
    let addRoleInfo = new RoleDto();
    console.log(this.addApplicazioneRoleForm.value.RuoloApp);
    if (ApplicazioneForm) {
      addRoleInfo.roleCode = this.addApplicazioneRoleForm.value.RuoloApp;
      addRoleInfo.applicationCode = this.addApplicazioneRoleForm.value.App;
    } else {
      addRoleInfo.roleCode = this.addRoleForm.value.Ruolo;
      addRoleInfo.applicationCode = this.applicazioneCorrente;
    }
    addRoleInfo.authEmailAddress = user.username;
    addRoleInfo.emailAddress = this.currentUser;
    if (this.addRoleForm.invalid) {
      return;
    }
    this.rolesService.postData('api/user/addrole', addRoleInfo, false).subscribe(result => {
      console.log(result);
      if (result != null || result['statusCode'] == 200) {
        if (result['result']['code'] == 400) {

          if (ApplicazioneForm) {
            this.showAll = false;
            this.errorMessage = result['result']['message'];
            this.showApplicationNotSaved = true;
            setInterval(() => {
              this.showApplicationNotSaved = false;
            }, 20000);
          } else {
            this.showAll = false;
            this.errorMessage = result['result']['message'];
            this.showRoleNotSaved = true;
            setInterval(() => {
              this.showRoleNotSaved = false;
            }, 20000);
          }
        } else {
          if (ApplicazioneForm) {
            this.showAll = false;
            this.showApplicationSaved = true;
            setInterval(() => {
              this.showRoleSaved = false;
            }, 6000);
          } else {
            this.showAll = false;
            this.showRoleSaved = true;
            setInterval(() => {
              this.showRoleSaved = false;
            }, 6000)
          }
        }
      } else {
        if (ApplicazioneForm) {
          this.showAll = true;
          this.showApplicationNotSaved = true;
          ;
          setInterval(() => {
            this.showApplicationNotSaved = false;
            ;
          }, 20000)
        } else {
          this.showAll = true;
          this.showRoleNotSaved = true;
          ;
          setInterval(() => {
            this.showRoleNotSaved = false;
            ;
          }, 20000)
        }
      }
    });
  }

  removeRole = async () => {
    if (window.confirm("Stai per cancellare il ruolo " + this.removeRoleForm.value.RemoveRole + " dall'applicazione " + this.removeRoleForm.value.RemoveRoleApplicazione + " per l'utente " + this.currentUser))
    {
      const user = await this.userService.getPrincipalAsync();
      let removeRoleInfo = new RoleDto();
      removeRoleInfo.roleCode = this.removeRoleForm.value.RemoveRole;
      removeRoleInfo.applicationCode = this.removeRoleForm.value.RemoveRoleApplicazione;
      removeRoleInfo.authEmailAddress = user.username;
      removeRoleInfo.emailAddress = this.currentUser;
      if (this.removeRoleForm.invalid) {
        return;
      }
      this.rolesService.postData('api/user/deleterole', removeRoleInfo, false).subscribe(result => {
        console.log(result);
        if (result != null || result['statusCode'] == 200) {
          if (result['result']['code'] == 400) {
            this.showAll = false;
            this.errorMessage = result['result']['message'];
            this.showRoleNotRemoved = true;
            setInterval(() => {
              this.showRoleNotRemoved = false;
            }, 20000)
          } else {
            this.showAll = false;
            this.showRoleRemoved = true;
            console.log(result['result']['Code']);
            setInterval(() => {
              this.showRoleRemoved = false;
            }, 6000)
          }
        } else {
          this.showAll = true;
          this.showRoleNotSaved = true;
          setInterval(() => {
            this.showRoleNotSaved = false;
          }, 20000)
        }
      });
    }
  }

  detailUsers = async () => {
    let users = await this.getUsers();
    users.forEach(x => {
      if (x['EmailAddress'] == this.currentDetailUser) {
        this.detail = x;
      }
    });
  }
}
